import { Injectable } from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService extends AbstractMessageListenerService<any> {
  constructor(private snackService: MatSnackBar) {
    super('error');
  }

  public override process(message: any): void {
    console.error('Room error', message);
    this.snackService.open(`${message.error.code}: ${message.error.details}`, undefined, {
      duration: 5000,
      panelClass: 'error',
      verticalPosition: 'top',
      horizontalPosition: 'end'
    });
  }
}
